"use client";

import GradientButtonIcon from "@/components/ui/custom/gradient-button-icon";
import { ArrowRight } from "lucide-react";
import React from "react";

function ButtonSectionPowerYourProducts() {
  return (
    <div className="mt-8 text-center lg:text-left">
      <GradientButtonIcon href="/contact-us" icon={<ArrowRight className="h-5 w-5" />}>
        Let’s Prompt Your Vision
      </GradientButtonIcon>
    </div>
  );
}

export default ButtonSectionPowerYourProducts;


